import featureFlagConstants from '~/common/helpers/featureFlagConstants';
import mockFeatures from '~/common/jsons/features-flag.json';

export function isMonitorAgentLogsCollectEnabled(
  treatment: string | undefined
): boolean {
  if (treatment === 'on') {
    return true;
  }

  const useLocalMockFallback =
    import.meta.env.DEV && import.meta.env.MODE !== 'test';

  if (useLocalMockFallback) {
    const mockTreatment =
      mockFeatures[
        featureFlagConstants.MONITOR_AGENT_LOGS_COLLECT_TEST_CASE as keyof typeof mockFeatures
      ]?.treatment;

    return mockTreatment === 'on';
  }

  return false;
}
